// extracted by mini-css-extract-plugin
export default {"drawer":"t5FHxwVWQD71qKKT48yOd","accordionDetails":"_1BCT_KEtJPdOfQghko4Ff1","createContainer":"XR0rRytG03IoVKlEn4SUf"};